import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import NotificationsIcon from 'assets/notifications.svg?react';
import { DownState } from 'components/DownState';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  image: {
    width: '90vmin',
    height: 'auto',
    maxWidth: 345,
  },
}));

export const AddCountyDownState = (): JSX.Element => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <DownState
      states={[
        {
          renderImage: (imageProps) => (
            <NotificationsIcon {...imageProps} className={classes.image} />
          ),
          description: (
            <Stack spacing={2}>
              <Typography variant="h2" align="center">
                {t('notifications.addCounties.onboardingTitle')}
              </Typography>
              <Typography>
                {t('notifications.addCounties.onboardingDescription')}
              </Typography>
            </Stack>
          ),
          Button: (
            <Button
              fullWidth
              size="large"
              component={Link}
              to="/notifications/add_counties"
            >
              {t('notifications.addCounty')}
            </Button>
          ),
          containerProps: {
            sx: {
              flex: 1,
              justifyContent: 'space-between',
            },
          },
        },
      ]}
    />
  );
};
